// extracted by mini-css-extract-plugin
export default {"button":"Button_button__dXAUs","primary":"Button_primary__dQH6j","secondary":"Button_secondary__zC+XT","danger":"Button_danger__zzv1M"};